import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const back = localStorage.getItem("pp_return") || "/app";
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-10 bg-paper px-4">
      <Logo to="/app" />
      <div className="w-full max-w-md rounded-2xl border border-paper-border bg-white p-10 text-center" data-testid="payment-cancel-card">
        <h1 className="text-3xl">Checkout cancelled</h1>
        <p className="mt-2 text-ink-soft">No charge was made. Your document is saved exactly as you left it.</p>
        <button className="btn-thread mt-6" onClick={() => navigate(back)} data-testid="payment-cancel-back-btn">Back to editing</button>
      </div>
    </div>
  );
}
